import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {
    type OttopilotEventTemplateConfiguration,
    ottopilotEventTemplateConfigurationValidator,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEventTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotEventsWorkspaceCapabilityConfiguration = {
    /** Business configuration and parent relationship keyed by Event template ID, not object ID. Capability revisions and audit snapshots version this map. */
    eventTemplates: Record<Uuid, {
        configuration: OttopilotEventTemplateConfiguration;
        eventContainerTemplateId: Uuid;
    }>;
};

export const ottopilotEventsWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotEventsWorkspaceCapabilityConfiguration> = zod.strictObject({
    eventTemplates: zod.record(uuidZodValidator, zod.strictObject({
        configuration: ottopilotEventTemplateConfigurationValidator,
        eventContainerTemplateId: uuidZodValidator,
    })),
});
